import ApiService from './api';
import type { Announcement, AnnouncementResponse } from '~/types/api';

/**
 * Duyuru mesajları için API işlemleri
 */
export default class AnnouncementService {
  private static instance: AnnouncementService;
  private apiService: ApiService;
  private endpoint: string = '/public/announcements';

  private constructor() {
    this.apiService = ApiService.getInstance();
  }

  /**
   * Singleton örneği al
   */
  public static getInstance(): AnnouncementService {
    if (!AnnouncementService.instance) {
      AnnouncementService.instance = new AnnouncementService();
    }
    return AnnouncementService.instance;
  }

  /**
   * Aktif duyuruları getir
   * @param lang Dil kodu (örn: tr, en)
   */
  public async getActiveAnnouncements(lang: string = 'tr'): Promise<Announcement[]> {
    try {
      const response = await this.apiService.get<Announcement[]>(this.endpoint, { lang });
      
      if (response.status === 200 && response.data) {
        return response.data;
      }
      
      return [];
    } catch (error) {
      console.error('Duyurular alınırken hata oluştu:', error);
      return [];
    }
  }

  /**
   * Belirli bir duyuruyu getir
   * @param id Duyuru ID
   * @param lang Dil kodu (örn: tr, en)
   */
  public async getAnnouncementById(id: string, lang: string = 'tr'): Promise<Announcement | null> {
    try {
      const allAnnouncements = await this.getActiveAnnouncements(lang);
      return allAnnouncements.find(announcement => announcement.id === id) || null;
    } catch (error) {
      console.error(`ID: ${id} olan duyuru alınırken hata oluştu:`, error);
      return null;
    }
  }
} 